<div
  class="container-fluid"
  [ngClass]="{ 'component-loading': loading }"
  [ngStyle]="{
    'min-height': data?.length === 0 && !loading ? '80vh' : null,
  }"
>
  @if (data?.length === 0) {
    <div
      style="
        margin-top: auto;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
      "
    >
      <ds-empty-state />
    </div>
  } @else {
    <p-table
      class="p-table books-review-table"
      [value]="data"
      dataKey="code"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr class="t-head">
          <!-- <th style="width: 4rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
          <th pSortableColumn="code">
            Display Name <p-sortIcon field="code"></p-sortIcon>
          </th>
          <th pSortableColumn="code">
            Phone <p-sortIcon field="code"></p-sortIcon>
          </th>
          <th pSortableColumn="code">
            Email <p-sortIcon field="code"></p-sortIcon>
          </th>
          <th pSortableColumn="code">
            Created On <p-sortIcon field="code"></p-sortIcon>
          </th>

          <th pSortableColumn="code">ACTIONS</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="t-row">
          <!-- <td>
          <p-tableCheckbox [value]="item"></p-tableCheckbox>
        </td> -->
          <td>
            {{ item.display_name }}
          </td>
          <td>
            {{ item.primary_phone }}
          </td>
          <td>
            {{ item.primary_email_addr }}
          </td>
          <td>
            {{ item.create_time | amDateFormat: "MMM DD, YYYY" }}
          </td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
